<div class="flex flex-col h-full">
  <div>
    <h1>Bestyrelse</h1>
  </div>
  <p-tabs
    [(value)]="bestyrelseService.activeTab"
    class="flex-1 border-1 overflow-hidden">
    <p-tablist>
      <p-tab value="list"><i class="pi pi-list"></i> Liste</p-tab>
      @if (
        bestyrelseService.selectedBestyrelsesmedlem() ||
        bestyrelseService.mode() === 'create'
      ) {
        <p-tab value="detail"><i class="pi pi-file"></i> Detaljer</p-tab>
      }
      @if (bestyrelseService.activeTab() !== 'detail') {
        <div class="mt-2 ml-8">
          <p-button
            icon="pi pi-plus"
            outlined
            label="Opret bestyrelsesmedlem"
            (click)="bestyrelseService.opretBestyrelsesmedlem()"></p-button>
        </div>
      }
    </p-tablist>
    <p-tabpanels class="overflow-hidden">
      <p-tabpanel value="list">
        <app-letpensiondk-bestyrelse-list />
      </p-tabpanel>
      <p-tabpanel value="detail">
        <app-letpensiondk-bestyrelse-detail />
      </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</div>
